import { render } from "./CarouselCardSkeleton.vue?vue&type=template&id=a70a0f5e&scoped=true"
import script from "./CarouselCardSkeleton.vue?vue&type=script&lang=js"
export * from "./CarouselCardSkeleton.vue?vue&type=script&lang=js"

import "./CarouselCardSkeleton.vue?vue&type=style&index=0&id=a70a0f5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70a0f5e"]])

export default __exports__